import type { UnreadInAppMessagesQueryVariables } from '../definitions'

const getUnreadInAppMessagesQueryVariables = (
  userId: string,
): UnreadInAppMessagesQueryVariables => ({ userId })

export default getUnreadInAppMessagesQueryVariables
